import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";

function ProcurementTemplateForm(props) {
  const [shouldHideRows, setShouldHideRows] = useState(false);
  const quantityDeliveredRef = useRef(null);
  const useFMANSacksRef = useRef(null);
  const quantityDeductedForSacksRef = useRef(null);
  const didFarmerUseFManStacksRef = useRef(null);
  const loanQuantityDeductedRef = useRef(null);
  const outstandingLoanRef = useRef(null);
  // const quantityBalanceRef = useRef(null);
  const useHarvestingServicesRef = useRef(null);
  const hectaresHarvestedRef = useRef(null);
  const bagsThreshedRef = useRef(null);
  const grainsReceivedRef = useRef(null);
  const totalGrainsReceivedRef = useRef(null);
  const totalPriceRef = useRef(null);
  const priceForExcessGrainRef = useRef(null);
  const frmRef = useRef({});

  const calculateTotalGrainsReceived = () => {
    const quantityDelivered =
      parseFloat(quantityDeliveredRef.current?.value) || 0;
    const useFMANSacks = useFMANSacksRef.current?.checked;
    const quantityDeductedForSacks = useFMANSacks
      ? parseFloat(quantityDeductedForSacksRef.current?.value) || 0
      : 0;
    const loanQuantityDeducted =
      parseFloat(loanQuantityDeductedRef.current?.value) || 0;

    const useHarvestingServices = useHarvestingServicesRef.current?.checked;
    const grainsReceived = useHarvestingServices
      ? parseFloat(grainsReceivedRef.current?.value) || 0
      : 0;

    const totalGrainsReceived =
      quantityDelivered -
      quantityDeductedForSacks -
      loanQuantityDeducted -
      grainsReceived;

    if (totalGrainsReceivedRef.current) {
      totalGrainsReceivedRef.current.value = totalGrainsReceived.toFixed(2);
    }
  };

  const toggleQuantityDeductedReadonly = (isChecked) => {
    if (quantityDeductedForSacksRef.current) {
      quantityDeductedForSacksRef.current.readOnly = !isChecked;
    }
  };

  const handleFMANSacksChange = () => {
    const isChecked = useFMANSacksRef.current?.checked;

    toggleQuantityDeductedReadonly(isChecked);

    if (!isChecked && quantityDeductedForSacksRef.current) {
      if (quantityDeductedForSacksRef.current) {
        quantityDeductedForSacksRef.current.value = "0";
        quantityDeductedForSacksRef.current.readOnly = true;
      }
    } else if (quantityDeductedForSacksRef.current) {
      quantityDeductedForSacksRef.current.readOnly = false;
    }
    calculateTotalGrainsReceived();
  };
  const toggleHarvestingFieldsReadonly = (isChecked) => {
    if (hectaresHarvestedRef.current) {
      hectaresHarvestedRef.current.readOnly = !isChecked;
    }
    if (bagsThreshedRef.current) {
      bagsThreshedRef.current.readOnly = !isChecked;
    }
    if (grainsReceivedRef.current) {
      grainsReceivedRef.current.readOnly = !isChecked;
    }
  };

  const handleHarvestingServicesChange = () => {
    const isChecked = useHarvestingServicesRef.current?.checked;
    if (!isChecked) {
      setHarvestingServices("");
      if (hectaresHarvestedRef.current) hectaresHarvestedRef.current.value = "";
      if (bagsThreshedRef.current) bagsThreshedRef.current.value = "";
      if (grainsReceivedRef.current) grainsReceivedRef.current.value = "";

      frmRef.current["harvestingServices"].value = "";
      if (hectaresHarvestedRef.current)
        hectaresHarvestedRef.current.value = "0";
      if (bagsThreshedRef.current) bagsThreshedRef.current.value = "0";
      if (grainsReceivedRef.current) grainsReceivedRef.current.value = "0";

      if (frmRef.current["harvestingServices"])
        frmRef.current["harvestingServices"].disabled = true;
      if (hectaresHarvestedRef.current)
        hectaresHarvestedRef.current.readOnly = true;
      if (bagsThreshedRef.current) bagsThreshedRef.current.readOnly = true;
      if (grainsReceivedRef.current) grainsReceivedRef.current.readOnly = true;
    } else {
      if (frmRef.current["harvestingServices"])
        frmRef.current["harvestingServices"].disabled = false;
      if (hectaresHarvestedRef.current)
        hectaresHarvestedRef.current.readOnly = false;
      if (bagsThreshedRef.current) bagsThreshedRef.current.readOnly = false;
      if (grainsReceivedRef.current) grainsReceivedRef.current.readOnly = false;
    }
    calculateTotalGrainsReceived();
  };

  const calculateTotalPrice = () => {
    const totalGrainsReceived =
      parseFloat(totalGrainsReceivedRef.current?.value) || 0;
    const priceExcessGrain =
      parseFloat(priceForExcessGrainRef.current.value) || 0;

    const total = totalGrainsReceived * priceExcessGrain;
    if (totalPriceRef.current) {
      totalPriceRef.current.value = total.toFixed(2);
    }
  };

  const [ProcurementTemplateData, setProcurementTemplateData] = useState([]);
  const [warehouseId, setWarehouseId] = useState();
  const [warehosuedata, setWarehosuedata] = useState([]);
  const [stateId, setStateId] = useState();
  const [lgaId, setLgaId] = useState();
  const [farmerCategory, setFarmerCategory] = useState();
  const [varietyId, setVarietyId] = useState();
  const [statedata, setStatedata] = useState([]);
  const [lgadata, setLgadata] = useState([]);
  const [lgaFilterdata, setLgaFilterdata] = useState([]);
  const [cropdata, setCropData] = useState([]);
  const [varietydata, setVarietydata] = useState([]);
  const [varietyFilterdata, setVarietyFilterdata] = useState([]);
  const [farmerNo, setFarmerNo] = useState();
  const [farmerData, setFarmerData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [outstandingLoan, setOutstandingLoan] = useState(0);
  const [error, setError] = useState("");
  const [images1, setImages1] = useState([]);
  const [images2, setImages2] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageGroups1, setImageGroups1] = useState(0);
  const [imageGroups2, setImageGroups2] = useState(0);

  const [
    farmerAgronomyRecommendationData,
    setFarmerAgronomyRecommendationData,
  ] = useState([]);

  const [isNewFarmer, setIsNewFarmer] = useState(false);
  const [farmerName, setFarmerName] = useState();
  const [farmerId, setFarmerId] = useState();
  const [stateName, setStateName] = useState("");
  const [lga, setLga] = useState("");
  const [villageName, setVillageName] = useState("");
  const [mobile, setMobile] = useState("");
  const [plotName, setPlotName] = useState("");
  const [cropName, setCropName] = useState("");
  const [cropVariety, setCropVariety] = useState("");
  const [profileUrl1, setprofileUrl1] = useState();
  const [profileUrl2, setprofileUrl2] = useState();
  const [showForm, setShowForm] = useState(false);
  const [qcDetail, setQcDetail] = useState({
    moistureLevel: "",
    moistureValue: "",
    presenceOfInsect: "",
    screenings: "",
    foreignWheatGrainsPresent: "",
  });

  const [quantityDeliveredInBags, setQuantityDeliveredInBags] = useState();
  const [loanHectareSize, setLoanHectareSize] = useState();
  const [didFarmerUseFManStacks, setDidFarmerUseFManStacks] = useState();
  const [harvestingServices, setHarvestingServices] = useState();
  const [hectaresHarvested, setHectaresHarvested] = useState();
  const [totalPrice, setTotalPrice] = useState();
  const [dateOfHarvesting, setDateOfHarvesting] = useState();
  const [paymentDueToFarmer, setPaymentDueToFarmer] = useState();
  const [paymentMethod, setPaymentMethod] = useState();
  const [bankName, setBankName] = useState();
  const [accountNumber, setAccountNumber] = useState();
  const [nameOnTheAccount, setNameOnTheAccount] = useState();
  const [transactionNo, setTransactionNo] = useState();
  const [cropId, setCropId] = useState();
  const [loanRemaining, setLoanRemaining] = useState("");

  const currentDate = new Date().toISOString().slice(0, 10);

  const [procurementTempDate, setProcurementTempDate] = useState(currentDate);

  const handleDateChange = (e) => {
    setProcurementTempDate(e.target.value);
  };

  const [backImage1, setBackImage1] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [backImage2, setBackImage2] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [imageSrc1, setImageSrc1] = useState(`${backImage1}`);
  const [imageSrc2, setImageSrc2] = useState(`${backImage2}`);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const { sendRequest: getProcurementTemplateData } = useHttp();
  const { sendRequest: postProcurementTemplateDetails } = useHttp();
  // const frmRef = useRef({});

  const FillDetail = () => {
    getProcurementTemplateData(
      {
        url: `/api/procurementTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setProcurementTemplateData(res);
        }
      },
      (error) => {
        // console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getProcurementTemplateData]);

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getStateData } = useHttp();
  const getStateDetail = () => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // console.log("state", res);
          setStatedata(res);
        }
      }
    );
  };
  useEffect(() => {
    getStateDetail();
  }, [getStateData]);

  const { sendRequest: getLgaData } = useHttp();
  const getLgaDetail = () => {
    getLgaData(
      {
        url: `/api/lgaLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // console.log("lga", res);
          setLgadata(res);
        }
      }
    );
  };
  useEffect(() => {
    getLgaDetail();
  }, [getLgaData]);

  const loadLgaFilterData = (id) => {
    var lgalist = lgadata && lgadata.filter((item) => item.stateName == id);
    // console.log("lgalist", lgalist);
    setLgaFilterdata(lgalist);
  };

  const { sendRequest: getcropsData } = useHttp();
  const getcropsDetail = () => {
    getcropsData(
      {
        url: `/api/crops/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // console.log("crops", res);
          setCropData(res);
        }
      }
    );
  };
  useEffect(() => {
    getcropsDetail();
  }, [getcropsData]);

  const loadVarietyFilterData = (id) => {
    var varietylist =
      varietydata && varietydata.filter((item) => item.cropId == id);
    // console.log("varietylist", varietylist);
    setVarietyFilterdata(varietylist);
  };

  const { sendRequest: getVarietyData } = useHttp();
  const getVarietyDetail = () => {
    getVarietyData(
      {
        url: `/api/varieties/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // console.log("variety", res);
          setVarietydata(res);
        }
      }
    );
  };
  useEffect(() => {
    getVarietyDetail();
  }, [getVarietyData]);

  const { sendRequest: getFarmerLoanDetailList } = useHttp();

  const fillFarmerLoanDetailList = (farmerId) => {
    getFarmerLoanDetailList(
      {
        url: `/api/fillFarmerLoanDetailList/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${farmerId}`,
      },
      (data) => {
        // console.log("setFarmerList", data);
        var totalBalanceAmount = 0;
        if (data && data.length > 0) {
          totalBalanceAmount = data[0].totalBalanceAmount;
        }
        setOutstandingLoan(totalBalanceAmount);
      }
    );
  };
  useEffect(() => {
    fillFarmerLoanDetailList(farmerId);
  }, [farmerId]);

  const { sendRequest: getFarmerData } = useHttp();

  const getFarmerDetail = () => {
    getFarmerData(
      {
        url: "/api/getfarmerDetail/",
      },
      (res) => {
        if (res) {
          const { output } = res;
          // console.log("farmer", res);
          setFarmerData(output);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerDetail();
  }, [getFarmerData]);

  const { sendRequest: getFarmerAgronomyRecommendationData } = useHttp();

  const getFarmerAgronomyRecommendationDetail = () => {
    getFarmerAgronomyRecommendationData(
      {
        url: "/api/fillCropList/",
      },
      (res) => {
        if (res) {
          // console.log("fillCropList", res);
          setFarmerAgronomyRecommendationData(res);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerAgronomyRecommendationDetail();
  }, [getFarmerAgronomyRecommendationData]);

    const attachmentFolder=localStorage.getItem("attachmentFolder");

  const uploadProImage1 = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);

    //console.log("picData", picData);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/procurementTemplate/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("data1", data);
        const imageUrl1 = data.url;

        setImageSrc1(`${process.env.REACT_APP_FILE_URL}${imageUrl1}`);
        setBackImage1(`${process.env.REACT_APP_FILE_URL}${imageUrl1}`);
        setprofileUrl1(data.url);
        sessionStorage.setItem(
          "grainCollectionFormAttachment",
          `${process.env.REACT_APP_FILE_URL}${imageUrl1}`
        );

        setImages1((prevImages) => {
          const updatedImages1 = [
            ...prevImages,
            `${process.env.REACT_APP_FILE_URL}${imageUrl1}`,
          ];

          // Group the updated images into groups of 4
          const groupedImages1 = [];
          for (let i = 0; i < updatedImages1.length; i += 4) {
            groupedImages1.push(updatedImages1.slice(i, i + 4));
            console.log("groupedImages1", groupedImages1);
          }

          // Update imageGroups1 with the new grouped images
          setImageGroups1(groupedImages1);
          return updatedImages1;
        });
      })
      .catch((err) => console.error(err));
  };
  const uploadProImage2 = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);

    //console.log("picData", picData);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/procurementTemplate/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("data2", data);
        const imageUrl2 = data.url;

        setImages2((prevImages) => {
          const updatedImages2 = [
            ...prevImages,
            `${process.env.REACT_APP_FILE_URL}${imageUrl2}`,
          ];

          // Group the updated images into groups of 4
          const groupedImages2 = [];
          for (let i = 0; i < updatedImages2.length; i += 4) {
            groupedImages2.push(updatedImages2.slice(i, i + 4));
          }

          // Update imageGroups1 with the new grouped images
          setImageGroups2(groupedImages2);
          return updatedImages2;
        });

        setImageSrc2(`${process.env.REACT_APP_FILE_URL}${imageUrl2}`);
        setBackImage2(`${process.env.REACT_APP_FILE_URL}${imageUrl2}`);
        setprofileUrl2(data.url);
        sessionStorage.setItem(
          "grainBagsAttachment",
          `${process.env.REACT_APP_FILE_URL}${imageUrl2}`
        );
      })
      .catch((err) => console.error(err));
  };

  const handleChange = (event) => {
    const { id, value } = event.target;
    setQcDetail((prevDetails) => {
      const updatedDetails = { ...prevDetails, [id]: value };

      if (
        updatedDetails.presenceOfInsect === "No" &&
        updatedDetails.screenings === "Clean" &&
        updatedDetails.foreignWheatGrainsPresent === "No" &&
        updatedDetails.moistureLevel === "No"
      ) {
        setShowForm(true);
      } else {
        setShowForm(false);
      }

      return updatedDetails;
    });
  };

  const convertDateToInputFormat = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
  };


  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  useEffect(() => {
    if (outstandingLoan) {
      setLoanRemaining(outstandingLoan);
    }
  }, [outstandingLoan]);

  const calculateOutstandingLoan = (e) => {
    const newLoanAmount = e.target.value;
    setOutstandingLoan(newLoanAmount);
  };

  const handleLoanRemainingChange = (e) => {
    const value = e.target.value;
    // Allow only numeric input
    const numericValue = value.replace(/[^0-9.]/g, "");

    if (parseFloat(numericValue) > parseFloat(outstandingLoan)) {
      setError(`Remaining loan cannot be more than ${outstandingLoan}`);
      setLoanRemaining(outstandingLoan);
    } else {
      setError("");
      setLoanRemaining(numericValue);
    }
  };

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingProcurementTemplate = ProcurementTemplateData.some(
        (ProcurementTemplate) =>
          ProcurementTemplate.ProcurementTemplate === ProcurementTemplate
      );

      if (isExistingProcurementTemplate) {
        toast.error("Procurement Template Details already exists");
        return;
      }
    }

    const formattedQcDetail = [
      { qcText: "Moisture Level (in %)", qcResult: qcDetail.moistureLevel },
      { qcText: "Moisture Level (in %)", qcResult: qcDetail.moistureValue },
      { qcText: "Presence of Insects", qcResult: qcDetail.presenceOfInsect },
      { qcText: "Screenings", qcResult: qcDetail.screenings },
      {
        qcText: "Foreign Wheat Grains Present",
        qcResult: qcDetail.foreignWheatGrainsPresent,
      },
    ];

    console.log(formattedQcDetail);

    const selectedFarmer = farmerData.find(
      (farmer) => farmer.farmerNo === frmRef.current.farmerNo.value
    );
    const data = {
      procurementTemplateId: props.update
        ? props.update.procurementTemplateId
        : generateUniqueID(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
      warehouseId: frmRef.current.warehouseId.value || "",

      farmerName: farmerName,
      village: villageName,
      plotName: plotName,
      cropId: cropId,
      varietyId: varietyId,
      grainCollectionFormAttachment: props.update
        ? props.update.grainCollectionFormAttachment
        : imageGroups1.flatMap((group) =>
            group.map((url) => {
              return {
                ["urlAttachments"]: url,
              };
            })
          ),

      grainBagsAttachment: props.update
        ? props.update.grainBagsAttachment
        : imageGroups2.flatMap((group) =>
            group.map((url) => {
              return {
                ["urlAttachments"]: url,
              };
            })
          ),
      hectaresHarvested: hectaresHarvested,
      dateOfHarvesting: moment(dateOfHarvesting).format("DD/MM/YYYY"),
      procurementTempDate: moment(procurementTempDate).format("DD/MM/YYYY"),
      quantityDeliveredInBags: quantityDeliveredInBags,
      quantityDeliveredInKg: quantityDeliveredRef.current.value || 0,
      quantityDeductedForSacksInKg:
        quantityDeductedForSacksRef.current.value || 0,
      useFMANHarvestingServices: useHarvestingServicesRef.current.checked,
      useFMANSacks: useFMANSacksRef.current.checked,
      loanHectareSize: loanHectareSize,
      loanQuantityDeductedInKg: loanQuantityDeductedRef.current.value || 0,
      outstandingLoan: outstandingLoanRef.current.value,
      remainingLoanAmount: loanRemaining || 0,
      didFarmerUseFManStacks: didFarmerUseFManStacksRef.current.checked,
      harvestingServices: harvestingServices,
      category: farmerCategory,
      mobileNumber: mobile,
      state: stateName,
      lga: lgaId,
      hectaresHarvested: hectaresHarvestedRef.current.value || 0,
      bagsThreshed: bagsThreshedRef.current.value || 0,
      paymentDueToFarmer: paymentDueToFarmer,
      quantityOfGrainsReceivedForHarvestingInKg:
        grainsReceivedRef.current.value || 0,
      totalQuantityOfGrainsReceived: totalGrainsReceivedRef.current.value || 0,
      priceForExcessGrain: priceForExcessGrainRef.current.value,
      totalPrice: totalPriceRef.current.value,
      paymentMethod: frmRef.current.paymentMethod.value,
      bankName: bankName,
      accountNumber: accountNumber,
      nameOnTheAccount: nameOnTheAccount,
      qcDetail: formattedQcDetail,
      grainWithAMoistureContentAbove: qcDetail.moistureLevel,
      moistureLevel: qcDetail.moistureValue,
      presenceOfInsect: qcDetail.presenceOfInsect,
      screenings: qcDetail.screenings,
      foreignWheatGrainsPresent: qcDetail.foreignWheatGrainsPresent,
      transactionNo: transactionNo,
      entryTime: moment().format("HH:mm:ss"),
      entryLatLong,
    };
    console.log("const data", data);

    if (selectedData) {
      data["farmerId"] = selectedData.farmerId;
    }

    postProcurementTemplateDetails(
      {
        url: "/api/procurementTemplate/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(
          `Procurement Template Details ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      },
      (error) => {
        console.error("Error:", error);
        toast.error(error?.message || "Something went wrong");
      }
    );
  };

  const { sendRequest: getProcurementTemplate } = useHttp();

  useEffect(() => {
    console.log("props.update", props.update);

    if (props.update && props.update.procurementTemplateId) {
      const imageUrls1 = props.update
        ? props.update.grainCollectionFormAttachment.map((item) =>
            item.urlAttachments.startsWith("http")
              ? item.urlAttachments
              : `${process.env.REACT_APP_FILE_URL}${item.urlAttachments}`
          )
        : [];
      const groupedImages1 = [];
      for (let i = 0; i < imageUrls1.length; i += 4) {
        groupedImages1.push(imageUrls1.slice(i, i + 4));
      }
      setImageGroups1(groupedImages1);

      const imageUrls2 = props.update
        ? props.update.grainBagsAttachment.map((item) =>
            item.urlAttachments.startsWith("http")
              ? item.urlAttachments
              : `${process.env.REACT_APP_FILE_URL}${item.urlAttachments}`
          )
        : [];
      const groupedImages2 = [];
      for (let i = 0; i < imageUrls2.length; i += 4) {
        groupedImages2.push(imageUrls2.slice(i, i + 4));
      }
      setImageGroups2(groupedImages2);
      setWarehouseId(props.update.warehouseId);
      setStateId(props.update.warehouseId);
      setFarmerNo(props.update.farmerNo);
      setFarmerName(props.update.farmerName);
      setStateName(props.update.state);

      var lgalist =
        lgadata &&
        lgadata.filter((item) => item.stateName == props.update.state);
      // console.log("lgalist", lgalist);
      setLgaFilterdata(lgalist);

      setLga(props.update.lga);
      setMobile(props.update.mobileNumber);
      setPlotName(props.update.plotName);
      setFarmerCategory(props.update.category);
      setCropId(props.update.cropId);

      var varietylist =
        varietydata &&
        varietydata.filter((item) => item.cropId == props.update.cropId);
      // console.log("varietylist", varietylist);
      setVarietyFilterdata(varietylist);
      setVarietyId(props.update.varietyId);

      if (grainsReceivedRef.current) {
        grainsReceivedRef.current.value =
          props.update.totalQuantityOfGrainsReceived;
      }
      if (quantityDeliveredRef.current) {
        quantityDeliveredRef.current.value = props.update.quantityDeliveredInKg;
      }
      if (quantityDeductedForSacksRef.current) {
        quantityDeductedForSacksRef.current.value =
          props.update.quantityDeductedForSacksInKg;
      }
      if (loanQuantityDeductedRef.current) {
        loanQuantityDeductedRef.current.value =
          props.update.loanQuantityDeductedInKg;
      }
      if (grainsReceivedRef.current) {
        grainsReceivedRef.current.value =
          props.update.quantityOfGrainsReceivedForHarvestingInKg;
      }
      if (totalGrainsReceivedRef.current) {
        totalGrainsReceivedRef.current.value =
          props.update.totalQuantityOfGrainsReceived;
      }
      if (hectaresHarvestedRef.current) {
        hectaresHarvestedRef.current.value = props.update.hectaresHarvested;
      }
      if (useFMANSacksRef.current) {
        useFMANSacksRef.current.checked = !!props.update.useFMANSacks;
      }
      if (didFarmerUseFManStacksRef.current) {
        didFarmerUseFManStacksRef.current.checked =
          !!props.update.didFarmerUseFManStacks;
      }
      if (useHarvestingServicesRef.current) {
        useHarvestingServicesRef.current.checked =
          !!props.update.useFMANHarvestingServices;
      }
      if (bagsThreshedRef.current) {
        bagsThreshedRef.current.value = props.update.bagsThreshed;
      }
      if (totalPriceRef.current) {
        totalPriceRef.current.value = props.update.totalPrice;
      }
      if (priceForExcessGrainRef.current) {
        priceForExcessGrainRef.current.value = props.update.priceForExcessGrain;
      }

      setVillageName(props.update.village);
      setQuantityDeliveredInBags(props.update.quantityDeliveredInBags || "");
      setLoanHectareSize(props.update.loanHectareSize || "");
      setHarvestingServices(props.update.harvestingServices);
      setPaymentDueToFarmer(props.update.paymentDueToFarmer || 0);
      setPaymentMethod(props.update.paymentMethod);
      setTransactionNo(props.update.transactionNo);
      setBankName(props.update.bankName || "");
      setAccountNumber(props.update.accountNumber || "");
      setNameOnTheAccount(props.update.nameOnTheAccount || "");
      setDidFarmerUseFManStacks(!!props.update.didFarmerUseFManStacks);
      setLoanRemaining(props.update.remainingLoanAmount);
      setOutstandingLoan(props.update.outstandingLoan);
      setProcurementTempDate(
        convertDateToInputFormat(props.update.procurementTempDate)
      );
      setDateOfHarvesting(
        convertDateToInputFormat(props.update.dateOfHarvesting)
      );
      setQcDetail((qcDetail) => ({
        moistureLevel:
          props.update.grainWithAMoistureContentAbove ?? qcDetail.moistureLevel,
        moistureValue: props.update.moistureLevel ?? qcDetail.moistureValue,
        presenceOfInsect:
          props.update.presenceOfInsect ?? qcDetail.presenceOfInsect,
        screenings: props.update.screenings ?? qcDetail.screenings,
        foreignWheatGrainsPresent:
          props.update.foreignWheatGrainsPresent ??
          qcDetail.foreignWheatGrainsPresent,
      }));
      if (
        props.update.screenings === "Clean" &&
        props.update.presenceOfInsect === "No" &&
        props.update.foreignWheatGrainsPresent === "No" &&
        props.update.moistureLevel === "No"
      ) {
        setShowForm(false);
      } else {
        setShowForm(true);
      }
      toggleQuantityDeductedReadonly(!!props.update?.useFMANSacks);
      toggleHarvestingFieldsReadonly(props.update.useFMANHarvestingServices);
    }
  }, [props.update, farmerData, farmerAgronomyRecommendationData]);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const onFarmerChange = (e) => {
    const selectedId = e.target.value || 0;
    setFarmerNo(selectedId);
    setIsNewFarmer(selectedId === "New");

    if (selectedId === "New" || selectedId === "") {
      setFarmerName("");
      setStateName("");
      setLga("");
      setVillageName("");
      setMobile("");
      setPlotName("");
      setCropName("");
      setCropVariety("");
      setCropId("");
    } else {
      ongetFarmerDataChange(selectedId);
    }
  };

  const ongetFarmerDataChange = (farmerNo) => {
    const selectedFarmerList =
      farmerData && farmerData.filter((item) => item.farmerNo == farmerNo);

    var selectedFarmer = selectedFarmerList[0];
    setFarmerName(selectedFarmer.farmerName || "NA");
    setFarmerId(selectedFarmer.farmerId || "NA");
    setStateName(selectedFarmer.state || "");
    setVillageName(selectedFarmer.villageName || "NA");
    setMobile(selectedFarmer.mobile || "NA");
    var lgalist =
      lgadata &&
      lgadata.filter((item) => item.stateName == selectedFarmer.state);
    // console.log("lgalist", lgalist);
    setLgaFilterdata(lgalist);

    setLga(selectedFarmer.lga || "");
    setFarmerCategory(selectedFarmer.category || "");
    // console.log("selectedFarmer.lga", selectedFarmer.lga);

    const selectedFarmerAgroList =
      farmerAgronomyRecommendationData &&
      farmerAgronomyRecommendationData.filter(
        (agro) => agro.farmerNo == farmerNo
      );
    // console.log("selectedFarmerAgro", selectedFarmerAgroList);
    if (selectedFarmerAgroList) {
      var selectedFarmerAgro = selectedFarmerAgroList[0];
      setVarietyId(selectedFarmerAgro.cropVarietyId || "");
      setPlotName(selectedFarmerAgro.plotName || "NA");
      setCropId(selectedFarmerAgro.cropMasterId || "");
      loadVarietyFilterData(selectedFarmerAgro.cropMasterId || "");
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= 11) {
      setMobile(value);
    }
  };

  // const imageGroups1 = [];
  // for (let i = 0; i < images1.length; i += 4) {
  //   imageGroups1.push(images1.slice(i, i + 4));
  //   console.log("imageGroups1",imageGroups1)
  // }
  // const imageGroups2 = [];
  // for (let i = 0; i < images2.length; i += 4) {
  //   imageGroups2.push(images2.slice(i, i + 4));
  //   console.log("imageGroups2",imageGroups2)
  // }

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              &nbsp;
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Procurement Template</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date</label>
                        <input
                          type="date"
                          id="procurementTempDate"
                          name="procurementTempDate"
                          ref={(el) =>
                            (frmRef.current["procurementTempDate"] = el)
                          }
                          max={currentDate}
                          value={procurementTempDate}
                          onChange={handleDateChange}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Recieving Store</label>
                        <select
                          id="warehouseId"
                          className="form-control"
                          ref={(el) => (frmRef.current["warehouseId"] = el)}
                          value={warehouseId}
                          onChange={(e) => {
                            setWarehouseId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Warehouse</option>
                          {warehosuedata &&
                            warehosuedata.map((x) => (
                              <option
                                key={x.id}
                                warehouse-id={x.id}
                                value={x.id}
                              >
                                {x.name} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer's Code</label>
                        <select
                          id="farmerNo"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerNo"] = el)}
                          value={farmerNo}
                          onChange={onFarmerChange}
                          required
                          disabled={props.update}
                        >
                          <option value="">Select Farmer Code</option>
                          <option value="New">Non-FMAN Farmer</option>
                          {farmerData &&
                            farmerData.map((farmer) => (
                              <option
                                key={farmer.farmerId}
                                value={farmer.farmerNo}
                              >
                                {farmer.farmerName +
                                  "(" +
                                  farmer.farmerNo +
                                  ")"}{" "}
                                {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer's Name</label>
                        <input
                          type="input"
                          id="farmersName"
                          name="farmersName"
                          value={farmerName}
                          className="form-control"
                          readOnly={!isNewFarmer}
                          onChange={(e) => {
                            setFarmerName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>State</label>
                        <select
                          id="state"
                          className="form-control"
                          value={stateName}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "") {
                              id = e.target.value;
                            }
                            setStateName(id);
                            loadLgaFilterData(id);
                          }}
                          required
                          disabled={!isNewFarmer}
                        >
                          <option value="">Select State</option>
                          {statedata &&
                            statedata.map((x) => (
                              <option
                                key={x.state}
                                state-id={x.state}
                                value={x.stateName}
                              >
                                {x.stateName} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>LGA</label>
                        <select
                          id="lgaId"
                          className="form-control"
                          ref={(el) => (frmRef.current["lgaId"] = el)}
                          value={lga}
                          onChange={(e) => {
                            setLgaId(e.target.value);
                            setLga(e.target.value);
                          }}
                          required
                          disabled={!isNewFarmer}
                        >
                          <option value="">Select LGA</option>
                          {lgaFilterdata &&
                            lgaFilterdata.map((x, i) => (
                              <option key={i} value={x.lga}>
                                {x.lga} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Village</label>
                        <input
                          type="input"
                          id="village"
                          name="village"
                          value={villageName}
                          className="form-control"
                          readOnly={!isNewFarmer}
                          onChange={(e) => {
                            setVillageName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Mobile Number</label>
                        <input
                          type="number"
                          id="mobile"
                          name="mobile"
                          value={mobile}
                          className="form-control"
                          readOnly={!isNewFarmer}
                          onChange={handleMobileChange}
                          placeholder="Enter mobile number"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer Category</label>
                        <select
                          className="form-control"
                          id="farmerCategory"
                          name="farmerCategory"
                          ref={(el) => (frmRef.current["farmerCategory"] = el)}
                          value={farmerCategory}
                          onChange={(e) => setFarmerCategory(e.target.value)}
                          required
                          readOnly={!isNewFarmer}
                        >
                          <option value="">Select Category</option>
                          <option value="Demo Farmer">Demo Farmer</option>
                          <option value="Maize Outgrower">
                            Maize Outgrower
                          </option>
                          <option value="Outgrower">Outgrower</option>
                          <option value="Outgrower">Non Outgrower</option>
                          <option value="Research Plot">Research Plot</option>
                          <option value="Seed Production">
                            Seed Production
                          </option>
                          <option value="Soya Outgrower">Soya Outgrower</option>
                          <option value="Wheat Outgrower">
                            Wheat Outgrower
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Plot Name</label>
                        <input
                          type="input"
                          id="plotName"
                          name="plotName"
                          value={plotName}
                          onChange={(e) => {
                            setPlotName(e.target.value);
                          }}
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop</label>
                        <select
                          id="cropId"
                          className="form-control"
                          value={cropId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "") {
                              id = e.target.value;
                            }
                            setCropId(id);
                            loadVarietyFilterData(id);
                          }}
                          required
                          disabled={!isNewFarmer}
                        >
                          <option value="">Select Crop</option>
                          {cropdata &&
                            cropdata.map((x) => (
                              <option
                                key={x.cropId}
                                crop-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.cropName} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Variety Name</label>
                        <select
                          id="varietyId"
                          className="form-control"
                          value={varietyId}
                          onChange={(e) => {
                            setVarietyId(e.target.value);
                          }}
                          required
                          disabled={!isNewFarmer}
                        >
                          <option value="">Select Variety</option>
                          {varietyFilterdata &&
                            varietyFilterdata.map((x) => (
                              <option
                                key={x.varietyId}
                                variety-id={x.varietyId}
                                value={x.varietyId}
                              >
                                {x.varietyName} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <h5>QC Details</h5>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <p className="text-sm">
                          <label>
                            Moisture Level (in %) - Any grain with a moisture
                            content above 12% should be flagged and rejected.
                          </label>
                        </p>
                        <select
                          id="moistureLevel"
                          value={qcDetail.moistureLevel}
                          onChange={handleChange}
                          className="form-control"
                          disabled={props.update}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {qcDetail.moistureLevel === "No" && (
                          <input
                            type="text"
                            id="moistureValue"
                            placeholder="Enter Moisture %"
                            className="form-control"
                            value={qcDetail.moistureValue}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value <= 12) {
                                handleChange(e);
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <p>
                          <label style={{ paddingBottom: "22px" }}>
                            {" "}
                            Presence of Insects (if Yes, reject
                            purchase/repayment)
                          </label>
                        </p>
                        <select
                          id="presenceOfInsect"
                          value={qcDetail.presenceOfInsect}
                          onChange={handleChange}
                          className="form-control"
                          disabled={props.update}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <p>
                          <label style={{ paddingBottom: "43px" }}>
                            Screenings (To be rejected if unclean)
                          </label>
                        </p>
                        <select
                          id="screenings"
                          value={qcDetail.screenings}
                          onChange={handleChange}
                          className="form-control"
                          disabled={props.update}
                        >
                          <option value="">Select</option>
                          <option value="Clean">Clean</option>
                          <option value="Unclean">Unclean</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <p>
                          <label style={{ paddingBottom: "43px" }}>
                            Foreign Wheat Grains Present?
                          </label>
                        </p>
                        <select
                          id="foreignWheatGrainsPresent"
                          value={qcDetail.foreignWheatGrainsPresent}
                          onChange={handleChange}
                          className="form-control"
                          disabled={props.update}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <br />
                  {showForm && (
                    <>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Total quantity delivered (in bags)</label>
                            <input
                              type="text"
                              ref={(el) =>
                                (frmRef.current["quantityDeliveredInBags"] = el)
                              }
                              onChange={(e) =>
                                setQuantityDeliveredInBags(e.target.value)
                              }
                              id="quantityDeliveredInBags"
                              name="quantityDeliveredInBags"
                              value={quantityDeliveredInBags}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Total quantity delivered (in KG)</label>
                            <input
                              type="text"
                              ref={quantityDeliveredRef}
                              onChange={calculateTotalGrainsReceived}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label></label>
                            <div className="input-check">
                              <input
                                type="checkbox"
                                ref={useFMANSacksRef}
                                onChange={handleFMANSacksChange}
                                className="form-check-input"
                                style={{ marginTop: "7px", marginLeft: "15px" }}
                              />
                              <p
                                className="form-check-label"
                                style={{
                                  marginTop: "10px",
                                  marginLeft: "30px",
                                }}
                              >
                                {"Did Farmer use FMAN Sacks?"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Quantity deducted for Sacks (KG)</label>
                            <input
                              type="text"
                              ref={quantityDeductedForSacksRef}
                              onChange={calculateTotalGrainsReceived}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>
                              What is the Loan Hectare Size Taken this Season
                            </label>
                            <input
                              type="text"
                              id="loanHectareSize"
                              name="loanHectareSize"
                              value={loanHectareSize}
                              onChange={(e) =>
                                setLoanHectareSize(e.target.value)
                              }
                              ref={(el) =>
                                (frmRef.current["loanHectareSize"] = el)
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Outstanding Loan</label>
                            <input
                              type="text"
                              ref={outstandingLoanRef}
                              onChange={calculateOutstandingLoan}
                              value={outstandingLoan}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Input Loan (in KG)</label>
                            <input
                              type="text"
                              ref={loanQuantityDeductedRef}
                              onChange={calculateTotalGrainsReceived}
                              className="form-control"
                              disabled={isNewFarmer}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div className="input-check">
                              <input
                                type="checkbox"
                                ref={didFarmerUseFManStacksRef}
                                onChange={(e) =>
                                  setDidFarmerUseFManStacks(e.target.checked)
                                }
                                className="form-check-input"
                                value={didFarmerUseFManStacks}
                                style={{ marginTop: "7px", marginLeft: "15px" }}
                                disabled={isNewFarmer}
                              />
                              <p
                                className="form-check-label"
                                style={{
                                  marginTop: "10px",
                                  marginLeft: "30px",
                                }}
                              >
                                {"Did farmer Paid loan fully?"}
                              </p>
                            </div>
                            {didFarmerUseFManStacks && (
                              <div
                                className="form-group"
                                style={{ marginTop: "10px" }}
                              >
                                <input
                                  type="text"
                                  id="loanRemaining"
                                  value={loanRemaining}
                                  onChange={handleLoanRemainingChange}
                                  className="form-control"
                                  placeholder="Enter loan Amount Balance"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label></label>
                            <div className="input-check">
                              <input
                                type="checkbox"
                                style={{
                                  marginLeft: "10px",
                                }}
                                ref={useHarvestingServicesRef}
                                onChange={handleHarvestingServicesChange}
                                className="form-check-input"
                              />
                              <p
                                htmlFor={""}
                                className="form-check-label"
                                style={{
                                  marginTop: "10px",
                                  marginLeft: "30px",
                                }}
                              >
                                {
                                  "Did farmer use FMAN Harvesting/Threshing services?"
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Which of the Harvesting services?</label>
                            <select
                              id="harvestingServices"
                              className="form-control"
                              ref={(el) =>
                                (frmRef.current["harvestingServices"] = el)
                              }
                              value={harvestingServices}
                              onChange={(e) =>
                                setHarvestingServices(e.target.value)
                              }
                              disabled={
                                !useHarvestingServicesRef.current?.checked
                              }
                              required
                            >
                              <option value="">Select Service</option>
                              <option value="Harvesting">Harvesting</option>
                              <option value="Threshing">Threshing</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>How many hectares harvested?</label>
                            <input
                              type="text"
                              ref={hectaresHarvestedRef}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>How many bags Threshed/Harvested </label>
                            <input
                              type="text"
                              ref={bagsThreshedRef}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>
                              Quantity deducted for land preparation service
                              (kg)
                            </label>
                            <input
                              type="text"
                              ref={grainsReceivedRef}
                              onChange={calculateTotalGrainsReceived}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ marginTop: "22px" }}>
                              Date of threshing/harvesting
                            </label>
                            <input
                              type="date"
                              id="dateOfHarvesting"
                              name="dateOfHarvesting"
                              value={dateOfHarvesting}
                              className="form-control"
                              onChange={(e) => {
                                setDateOfHarvesting(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ marginTop: "22px" }}>
                              Excess Grain for purchase (in KG)
                            </label>
                            <input
                              type="text"
                              ref={totalGrainsReceivedRef}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ marginTop: "22px" }}>
                              Price for excess grain (NGN per KG)
                            </label>
                            <input
                              type="text"
                              id="priceForExcessGrain"
                              name="priceForExcessGrain"
                              ref={priceForExcessGrainRef}
                              onChange={(e) => {
                                calculateTotalPrice();
                              }}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ marginTop: "22px" }}>
                              Total Price(NGN per KG)
                            </label>
                            <input
                              type="text"
                              id="totalPrice"
                              name="totalPrice"
                              ref={totalPriceRef}
                              value={totalPrice}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>
                              Payment due to farmer for excess grains delivered
                              at the current buying rate per KG
                            </label>
                            <input
                              type="text"
                              id="paymentDueToFarmer"
                              name="paymentDueToFarmer"
                              value={paymentDueToFarmer}
                              onChange={(e) =>
                                setPaymentDueToFarmer(e.target.value)
                              }
                              ref={(el) =>
                                (frmRef.current["paymentDueToFarmer"] = el)
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Payment Method</label>
                            <select
                              id="paymentMethod"
                              className="form-control"
                              ref={(el) =>
                                (frmRef.current["paymentMethod"] = el)
                              }
                              value={paymentMethod}
                              onChange={(e) => {
                                setPaymentMethod(e.target.value);
                              }}
                              required
                            >
                              <option value="">Select Service</option>
                              <option value="Cash">Cash</option>
                              <option value="Cheque">Cheque</option>
                              <option value="Bank Transfer">
                                Bank Transfer
                              </option>
                              <option value="Mobile Money">Mobile Money</option>
                              <option value="Wallet">Wallet</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Bank/Wallet Name</label>
                            <input
                              type="text"
                              id="bankName"
                              name="bankName"
                              value={bankName}
                              onChange={(e) => setBankName(e.target.value)}
                              ref={(el) => (frmRef.current["bankName"] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Account/Wallet Number</label>
                            <input
                              type="text"
                              id="accountNumber"
                              name="accountNumber"
                              value={accountNumber}
                              onChange={(e) => setAccountNumber(e.target.value)}
                              ref={(el) =>
                                (frmRef.current["accountNumber"] = el)
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Name on the Account</label>
                            <input
                              type="text"
                              id="nameOnTheAccount"
                              name="nameOnTheAccount"
                              value={nameOnTheAccount}
                              onChange={(e) =>
                                setNameOnTheAccount(e.target.value)
                              }
                              ref={(el) =>
                                (frmRef.current["nameOnTheAccount"] = el)
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Transaction No:</label>
                            <input
                              type="text"
                              id="transactionNo"
                              name="transactionNo"
                              value={transactionNo}
                              ref={(el) =>
                                (frmRef.current["transactionNo"] = el)
                              }
                              onChange={(e) => {
                                setTransactionNo(e.target.value);
                              }}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      {!props.update && (
                        <div className="row">
                          <div className="col-md-1"></div>
                          <div className="card col-md-4 text-center">
                            <label style={{ marginTop: "10px" }}>
                              Capture Image of Grain Bags
                            </label>
                            <div className="form-group">
                              <img
                                src={`${backImage2}`}
                                className="user-image img-circle"
                                width="50"
                                height="50"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "-15px",
                                }}
                                alt="Image2"
                                onClick={() => setIsModalOpen2(true)}
                              />

                              <div className="input-group">
                                <div className="custom-file">
                                  <label
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "15px",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      className="custom-file-input"
                                      id="file2"
                                      accept="image2/*"
                                      onChange={uploadProImage2}
                                    />
                                    Upload
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1"></div>
                          <div className="card col-md-4 text-center">
                            <label style={{ marginTop: "10px" }}>
                              Capture Image of Grain Collection Form
                            </label>
                            <div className="form-group">
                              <img
                                src={`${backImage1}`}
                                className="user-image img-circle"
                                width="50"
                                height="50"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "-15px",
                                }}
                                alt="Image1"
                                onClick={() => setIsModalOpen1(true)}
                              />

                              <div className="input-group">
                                <div className="custom-file">
                                  <label
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "15px",
                                    }}
                                  >
                                    <input
                                      type="file"
                                      className="custom-file-input"
                                      id="file1"
                                      accept="image1/*"
                                      onChange={uploadProImage1}
                                    />
                                    Upload
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-12">
                          <div
                            id="carouselExampleCustom"
                            className="carousel slide"
                            style={{ position: "relative", marginTop: "30px" }}
                          >
                            <label>Grain Bags Images</label>
                            <div className="carousel-inner">
                              {imageGroups2.length > 0 ? (
                                imageGroups2.map((group, index) => (
                                  <div
                                    key={index}
                                    className={`carousel-item ${
                                      index === currentIndex ? "active" : ""
                                    }`}
                                  >
                                    <div className="row w-50px">
                                      {group.map((image, idx) => (
                                        <div key={idx} className="col-3">
                                          <img
                                            src={image}
                                            className="d-block w-100"
                                            alt={`Observation ${
                                              index * 4 + idx + 1
                                            }`}
                                            style={{
                                              borderRadius: "5px",
                                              objectFit: "fill",
                                              height: "300px",
                                              width: "100px",
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p style={{ textAlign: "center" }}>
                                  No images available
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div
                            id="carouselExampleCustom"
                            className="carousel slide"
                            style={{ position: "relative" }}
                          >
                            <label>Grain Collection Form Images</label>
                            <div className="carousel-inner">
                              {imageGroups1.length > 0 ? (
                                imageGroups1.map((group, index) => (
                                  <div
                                    key={index}
                                    className={`carousel-item ${
                                      index === currentIndex ? "active" : ""
                                    }`}
                                  >
                                    <div className="row w-50px">
                                      {group.map((image, idx) => (
                                        <div key={idx} className="col-3">
                                          <img
                                            src={image}
                                            className="d-block w-100"
                                            alt={`Observation ${
                                              index * 4 + idx + 1
                                            }`}
                                            style={{
                                              borderRadius: "5px",
                                              objectFit: "fill",
                                              height: "300px",
                                              width: "100px",
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p style={{ textAlign: "center" }}>
                                  No images available
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-1"></div>
                        <div className="col-md-1">
                          <button
                            className="btn btn-primary my-2"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      {isModalOpen1 && (
        <div
          style={{
            position: "fixed",
            top: "12.5%",
            left: "25%",
            width: "60%",
            height: "60%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsModalOpen1(false);
            }
          }}
        >
          <img
            src={backImage1}
            alt="Enlarged"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              pointerEvents: "none",
            }}
          />
        </div>
      )}
      {isModalOpen2 && (
        <div
          style={{
            position: "fixed",
            top: "12.5%",
            left: "25%",
            width: "60%",
            height: "60%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsModalOpen2(false);
            }
          }}
        >
          <img
            src={backImage2}
            alt="Enlarged"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              pointerEvents: "none",
            }}
          />
        </div>
      )}
    </>
  );
}

export default ProcurementTemplateForm;
